import React, { useMemo } from 'react';

const cleanInput = (text = '') => {
    return text
        .replace(/\*\s+\*/g, '**')
        .replace(/\s+\^/g, '^')
        .replace(/\^\s+/g, '^');
};

const ViewFileFormattedText = React.memo(({ originalText = '' }) => {

    const parts = useMemo(() => {
        const cleaned = cleanInput(originalText);
        return cleaned.split(/(\*|\^)/).filter(p => p.trim() !== '');
    }, [originalText]);

    return (
        <div>
            {parts.map((part, index) => {
                if (index === 0) {
                    return <span key={index} className="purple">{part}</span>;
                }

                if (part === '^') {
                    return <span key={index} className="red">^</span>;
                }

                return part;
            })}
        </div>
    );
});

export default ViewFileFormattedText;




// const ViewFileFormattedText = ({ originalText }) => {
//     // Split the text by '*'
//     const parts = originalText?.split(/(\*|\^)/);

//     // Iterate through the parts and apply styles
//     const format = parts?.map((part, index) => {
//         if (index === 0) {
//             // First part, apply purple color to the single letter
//             return `<span class="purple">${part}</span>`;
//         } else if (part === '*') {
//             return `<span class="orange">${part}</span>`
//         } else if (part === '^') {
//             return `<span class="red">${part}</span>`
//         } else {
//             // Odd index, apply green color to starting letters and purple color to words with spaces
//             const words = part?.trim()?.split(' ');
//             const firstWord = words[0];
//             const restOfWords = words?.slice(1)?.join(' ');

//             if (restOfWords?.length > 0) {
//                 return `<span class="green">${firstWord} ${restOfWords}</span>`;
//             } else {
//                 return `<span>${firstWord}</span>`;
//             }
//         }
//     }).join('');

//     return <div dangerouslySetInnerHTML={{ __html: format }} />
// };
// export default ViewFileFormattedText;